import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { Svg } from "common/assets";
import { useResolution } from "common/hooks";
import { EColors } from "common/styles";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { darkTheme, GOOGLE_KEY, markers } from "./data";

export const MapContainer = () => {
  const { isMinScreen768 } = useResolution();
  const [loading, setLoading] = useState(true);

  const mapStyles = {
    height: isMinScreen768 ? "551px" : "343px",
    width: "100%",
  };

  const mapOptions = {
    styles: darkTheme,
  };

  const center = {
    lat: isMinScreen768 ? 51.03794495029081 : 50.9002983, // Широта
    lng: isMinScreen768 ? 31.891528243969308 : 34.8175409, // Долгота
  };

  const MarkerStyled = styled(Marker)`
    width: 44px;
    height: 44px;
    color: ${EColors.accent_300};
    fill: ${EColors.accent_300};
  `;

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  return (
    <LoadScript googleMapsApiKey={GOOGLE_KEY}>
      <GoogleMap
        mapContainerStyle={mapStyles}
        zoom={8}
        center={center}
        options={mapOptions}
      >
        {!loading &&
          markers.map((marker, index: number) => (
            <MarkerStyled
              key={index}
              position={{ lat: marker.lat, lng: marker.lng }}
              icon={Svg.Pin}
            />
          ))}
      </GoogleMap>
    </LoadScript>
  );
};
